<script lang="ts">
  import Route from '@dabble/toolkit/Route.svelte';
  import AdminSection from './AdminSection.svelte';
</script>

<Route path="/admin/*" component={AdminSection} />
